import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faParagraph } from '@fortawesome/pro-light-svg-icons';

export type ProLightParagraphProps = IconComponentProps;

export const ProLightParagraph = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightParagraphProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faParagraph}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faParagraph}
    />
  );
};

ProLightParagraph.displayName = 'ProLightParagraph';
